module.exports = __webpack_public_path__ + "img/curtain_up_0.8ca9207d.svg";